export default {
  /**
   * Added this method so that it can be called from the DirectoryItemTable and
   * the Google and M365 aside panels.
   */
  isDuplicateDirectoryName(directories, payload = {}) {
    const { id, name, type } = payload;

    // Check the list of directories of the specified type to see if there
    // are any name duplications.
    return directories.some(directory => (
      directory.id !== id
      && directory.type === type
      && directory.name === name
    ));
  },

  /**
   * Gets string used for Directory Integration dropdown menu items
   * when the "plus sign" is hit in the ItemTableActionBar on the
   * Users, Cloud Directories, and HR Directories main panels.
   * @param {String} integrationTypeDisplayName Integration type display name const.
   * @param {Boolean} addRealTimePrefix Adds "Real-time" prefixed to the returned string.
   */
  getDirectoryImportMenuItemText(integrationTypeDisplayName, addRealTimePrefix = false) {
    const fromIntegrationText = `from ${integrationTypeDisplayName}`;

    return addRealTimePrefix
      ? `Real-time sync ${fromIntegrationText}`
      : `${integrationTypeDisplayName}`;
  },
};
